module.exports = __webpack_public_path__ + "img/logo_gross.f6f5e87a.png";